import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'invoicing',
});

export const newInvoiceRouteRef = createRouteRef({
  id: 'invoicing-new-invoice',
});